export default __webpack_public_path__ + "static/media/Trade_Gothic_LT_Bold.47451eaa.woff";